<span>{{ selection.objects?.length }}{{ selection.limit ? '/' + selection.limit : '' }}</span>
